import gql from "graphql-tag"

export const DELETE_EXTERNAL_PRICE_CONFIG = gql`
  mutation deleteExternalPriceConfig($id: ID!) {
    deleteExternalPriceConfig(id: $id) {
      status
    }
  }
`
